import { itemsOnPage } from "../assets/const";
import { createNotification } from "../components/Notifications/Notifications";
import { api } from "../App";

import {
    SET_STUDY_PLANS_DO,
    SET_STUDY_PLAN_DO_BY_ID,
    SET_STUDY_PLAN_DO_COURSES_LIST,
    SET_STUDY_PLANS_LOADING,
    SET_STUDY_PLANS_PAGE,
    SET_STUDY_PLAN_LOADING,
    SET_STUDY_PLAN_DO_FILES,
} from "./types";

export const setPage = (pageNumber) => ({ type: SET_STUDY_PLANS_PAGE, payload: pageNumber })


export const getStudyPlansDO = (params) => async (dispatch, getState) => {
    const { pageNumber } = getState().studyPlans;
    const max_results = itemsOnPage;
    const paginate_from = itemsOnPage * pageNumber;
    let copyParams = {
        ...params,
        limit: max_results,
        offset: paginate_from
    };

    try {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: true });
        const { data } = await api.get(`/xp_study_plans`, { params: copyParams });
        dispatch({ type: SET_STUDY_PLANS_DO, payload: data });
    } catch (error) {
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: false });
    }
};

export const getStudyPlanDOById = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: true });
        const { data } = await api.get(`/xp_study_plans/${id}`);
        dispatch({ type: SET_STUDY_PLAN_DO_BY_ID, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: false });
    }
}

export const deleteStudyPlansDO = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: true });
        await api.delete(`/xp_study_plans/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getStudyPlansDO());
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        dispatch({ type: SET_STUDY_PLANS_LOADING, payload: false });
    }
};

export const editStudyPlanDO = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        await api.put(`/xp_study_plans/${reqData.xp_key}`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansDO());
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

export const createStudyPlanDO = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        await api.post(`/xp_study_plans`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansDO());
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

export const createCopyStudyPlanDO = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        await api.post(`/xp_study_plans/${id}/copy`);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlansDO());
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

// МО Список предметов
export const getStudyPlanDOCoursesList = (id) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        const { data } = await api.get(`/xp_study_plans/${id}/courses`);
        dispatch({ type: SET_STUDY_PLAN_DO_COURSES_LIST, payload: data });
    } catch (ERR) {
    } finally {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

export const addStudyPlanDOCourse = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        await api.post(`/xp_study_plans/courses`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlanDOCoursesList(reqData.xp_tracks));
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

export const editStudyPlanDOCourse = (reqData) => async (dispatch) => {
    try {
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: true });
        await api.put(`/xp_study_plans/${reqData.xp_tracks}/courses/${reqData.xp_courses}`, reqData);
        createNotification('success', 'Успешно');
    } catch (error) {
        const message = error.response?.data?.error || 'Ошибка';
        createNotification('error', message);
    } finally {
        await dispatch(getStudyPlanDOCoursesList(reqData.xp_tracks));
        dispatch({ type: SET_STUDY_PLAN_LOADING, payload: false });
    }
};

export const createStudyPlanDOFile = (file, id) => async (dispatch) => {
    try {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/xp_study_plans/${id}`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        createNotification('success', 'Успешно');
        await dispatch(getStudyPlanDOById(id));
    } catch (ERR) {
    }
};

export const getStudyPlanDOFiles = (id) => async (dispatch) => {
    try {
        const { data } = await api.get(`/xp_study_plans/${id}/file`);
        dispatch({ type: SET_STUDY_PLAN_DO_FILES, payload: data });
    } catch (ERR) {
        dispatch({ type: SET_STUDY_PLAN_DO_FILES, payload: null });
    }
};
